import { ApplicationVersion } from '@/micro/types/version.type'
import commons from './commons'
import es_AR from './locale/es_AR'
import es_ES from './locale/es_ES'
import es_CR from './locale/es_CR'
import es_DO from './locale/es_DO'
import es_CO from './locale/es_CO'
import es_MX from './locale/es_MX'
import { merge } from 'lodash-es'

export const getTranslations = (country?: ApplicationVersion) => {
  let translations = { ...commons }

  // Diccionario de traducciones por país
  const transDictionary: Partial<Record<ApplicationVersion, any>> = {
    argentina: es_AR,
    spain: es_ES,
    costaRica: es_CR,
    republicaDominicana: es_DO,
    colombia: es_CO,
    mexico: es_MX,
  }

  // Si el país es válido, se agrega la traducción del país al commons
  if (country && transDictionary[country]) {
    return merge({}, commons, transDictionary[country])
  }

  return translations
}
